import { Button, Divider, Stack } from '@mui/material'

type Props = {
  onResetAll: () => void
  onSubmit: () => void
  onResetSection: () => void
}

export const FilterActions = (props: Props) => {
  const handleResetSection = () => props.onResetSection()
  const handleResetAll = () => props.onResetAll()
  const handleSubmit = () => props.onSubmit()

  return (
    <Stack
      direction="row"
      alignItems="baseline"
      justifyContent="flex-end"
      spacing={1}
    >
      <Button variant="text" color="secondary" onClick={handleResetAll}>
        Reset All
      </Button>
      <Button variant="text" color="secondary" onClick={handleResetSection}>
        Reset Section
      </Button>
      <Divider orientation="vertical" color="secondary" flexItem />
      <Button variant="contained" onClick={handleSubmit}>
        Apply to Search
      </Button>
    </Stack>
  )
}
